/* ABB gift shop (2 Oct 2026). Behaviour for the abb-gs-* sections:
   1. Add to basket on the present cards (one tap, then the site's normal
      cart-page journey: ajaxProduct:added lets abb-gift-engine settle the free
      gifts before abb-cart-page-redirect moves to /cart).
   2. The voucher builder, run separately for the phone and desktop markup.
   3. A gentle swing of the gift tags the first time they scroll into view. */
(function () {
  'use strict';

  function add(variantId, props) {
    var properties = Object.assign({ _abb_source: 'gift-shop' }, props || {});
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: properties }] })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw new Error((e && e.description) || 'add failed'); }); }
      return r.json();
    });
  }

  function busy(btn, on, text) {
    var label = btn.querySelector('[data-gs-label]') || btn;
    if (on) {
      btn.setAttribute('data-gs-prev', label.textContent);
      label.textContent = text || 'Adding…';
      btn.disabled = true;
    } else {
      label.textContent = btn.getAttribute('data-gs-prev') || label.textContent;
      btn.disabled = false;
    }
  }

  function added(btn) {
    var label = btn.querySelector('[data-gs-label]') || btn;
    label.textContent = 'Added ✓';
    btn.classList.add('is-added');
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    setTimeout(function () {
      btn.classList.remove('is-added');
      busy(btn, false);
    }, 2400);
  }

  function failed(btn, err) {
    var label = btn.querySelector('[data-gs-label]') || btn;
    label.textContent = (err && /sold|stock|available/i.test(err.message)) ? 'Sorry, sold out' : 'Please try again';
    setTimeout(function () { busy(btn, false); }, 2200);
  }

  /* ---------- 1. present cards ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gs-add]') : null;
    if (!btn || btn.disabled) { return; }
    e.preventDefault();
    busy(btn, true);
    add(btn.getAttribute('data-gs-add')).then(function () { added(btn); }).catch(function (err) { failed(btn, err); });
  });

  /* ---------- 2. voucher builder ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }

  function voucher(root) {
    var chips = root.querySelectorAll('[data-gs-v-chip]');
    var amount = root.querySelector('[data-gs-v-amount]');
    var btn = root.querySelector('[data-gs-v-add]');
    var label = btn.querySelector('[data-gs-label]');
    var who = root.querySelector('[data-gs-v-who]');
    var email = root.querySelector('[data-gs-v-email]');
    var name = root.querySelector('[data-gs-v-name]');
    var msg = root.querySelector('[data-gs-v-msg]');
    var count = root.querySelector('[data-gs-v-count]');
    var date = root.querySelector('[data-gs-v-date]');
    var err = root.querySelector('[data-gs-v-err]');
    var current = null;

    var today = new Date();
    date.min = iso(today);
    date.max = iso(new Date(today.getTime() + 90 * 86400000)); /* Shopify sends up to 90 days ahead */
    date.value = iso(today);

    function pick(chip) {
      chips.forEach(function (c) { c.setAttribute('aria-checked', c === chip ? 'true' : 'false'); });
      current = { vid: chip.getAttribute('data-vid'), label: chip.getAttribute('data-label') };
      if (amount && amount.textContent !== current.label) {
        amount.classList.add('is-swapping');
        setTimeout(function () {
          amount.textContent = current.label;
          amount.classList.remove('is-swapping');
        }, 170);
      }
      if (!btn.disabled) { label.textContent = 'Add ' + current.label + ' voucher to basket'; }
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { pick(chip); });
      chip.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(chips);
        var i = list.indexOf(chip);
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = list[(i + 1) % list.length]; }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = list[(i - 1 + list.length) % list.length]; }
        if (next) { e.preventDefault(); next.focus(); pick(next); }
      });
    });
    var start = root.querySelector('[data-gs-v-chip][aria-checked="true"]') || chips[0];
    if (start) { pick(start); }

    root.querySelectorAll('[data-gs-v-mode]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var them = root.querySelector('[data-gs-v-mode][value="them"]').checked;
        who.hidden = !them;
        err.hidden = true;
        if (them) { setTimeout(function () { name.focus(); }, 30); }
      });
    });

    msg.addEventListener('input', function () { count.textContent = (200 - msg.value.length) + ' left'; });

    btn.addEventListener('click', function () {
      if (!current || btn.disabled) { return; }
      var props = {};
      var them = root.querySelector('[data-gs-v-mode][value="them"]').checked;
      if (them) {
        var to = email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(to)) {
          err.hidden = false;
          email.focus();
          return;
        }
        err.hidden = true;
        /* Shopify's own gift card recipient fields: these exact names make
           Shopify email the voucher to them, on the date, with the message. */
        props['__shopify_send_gift_card_to_recipient'] = 'on';
        props['Recipient email'] = to;
        if (name.value.trim()) { props['Recipient name'] = name.value.trim(); }
        if (msg.value.trim()) { props['Message'] = msg.value.trim(); }
        if (date.value && date.value !== date.min) { props['Send on'] = date.value; }
        props['__shopify_offset'] = new Date().getTimezoneOffset().toString();
      }
      busy(btn, true);
      add(current.vid, props).then(function () { added(btn); }).catch(function (e) { failed(btn, e); });
    });
  }

  /* ---------- 3. tag swing ---------- */
  function swing(el) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
    if (!('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          el.classList.add('is-swinging');
          io.disconnect();
          setTimeout(function () { el.classList.remove('is-swinging'); }, 3200);
        }
      });
    }, { threshold: 0.45 });
    io.observe(el);
  }

  function init() {
    document.querySelectorAll('[data-gs-voucher]').forEach(function (root) {
      if (root.getAttribute('data-gs-ready')) { return; }
      root.setAttribute('data-gs-ready', '1');
      voucher(root);
    });
    document.querySelectorAll('[data-gs-swing]').forEach(function (el) {
      if (el.getAttribute('data-gs-ready')) { return; }
      el.setAttribute('data-gs-ready', '1');
      swing(el);
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
